import { ICommand, IQuery } from 'core-ts-types';
import { ISectionsDatasource } from '../../views/sections/datasources/sections_datasource';
import * as _4 from 'lodash4';
import { ScheduledSectionsQuery } from '../../views/course_scheduler/queries/scheduled_sections_query';
import { CRNSearchResultsQuery } from './queries/crn_search_query';
import { ScheduledSectionServant } from '../../views/course_scheduler/servants/scheduled_section_servant';
import { ITermCoursesDatasource } from '../../views/term_courses/datasources/term_courses_datasource';
import { TermCourseServant } from '../../views/term_courses/servants/term_course_servant';
import { MultiSectionServant } from '../../views/course_scheduler/servants/multi_section_servant';
const SEARCH_MIN_LENGTH = 2;
export class CRNSearchController {
  private searchInputValue: string;
  private termId: number;
  private query: any;
  private showAlert: boolean = false;
  private alertConfig: {
    theme: string;
    message: string;
    hideResults: boolean;
  };
  private ALERT_TYPES: any;
  private sectionLabel: string = 'Section';
  private searchValidationError: boolean = false;

  constructor(
    private crnSearchCommand: ICommand,
    private crnClearSearchCommand: ICommand,
    private ngCRNSearchResultsQuery: CRNSearchResultsQuery,
    private ngScheduledSectionsQuery: ScheduledSectionsQuery,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngTermCoursesDatasource: ITermCoursesDatasource,
    private $stateParams: ng.ui.IStateParamsService,
    private $state: ng.ui.IStateService,
    private ngMultiSectionServant: MultiSectionServant,
    private ngTermCourseServant: TermCourseServant,
    private ngScheduledSectionServant: any,
    private ngCRNSearchModel: any,
    private appConfigModel: any
  ) {
    this.ALERT_TYPES = {
      searchValidationError: {
        theme: 'error',
        message: `Minimum 3 characters required.`,
        hideResults: true
      },
      noResults: {
        theme: 'error',
        message: `Your search returned 0 results. Refine your search for better results.`,
        hideResults: true
      },
      serverError: {
        theme: 'error',
        message: 'A network error occurred. Please try again.',
        hideResults: true
      }
    };
  }
  $onInit() {
    this.termId = this.$stateParams.termId;
    this.query = {
      search: this.ngCRNSearchResultsQuery
    };
    this.sectionLabel = this.appConfigModel.model.member_configs['section_label'] || 'Section';
    this.setFocusOnSearchPanel();
  }

  setFocusOnSearchPanel() {
    const searchPanelHeading = document.getElementById('crnSearchheading');
    if (searchPanelHeading) {
      searchPanelHeading.focus();
    }
  }
  $onDestroy() {
    this.crnClearSearchCommand();
  }

  exitSearch() {
    this.gotoRegistration();
  }
  closeAlert() {
    this.showAlert = false;
    this.alertConfig = {
      theme: '',
      message: '',
      hideResults: false
    };
  }

  configAndShowAlert(type: string) {
    this.alertConfig = this.ALERT_TYPES[type];
    this.showAlert = true;
  }

  search(event: JQueryEventObject & { detail: { value: { crn: string } } }) {
    this.searchInputValue = _4.get(event, 'detail.value.crn', '');
    this.closeAlert();
    this.crnClearSearchCommand();
    if (_4.lte(this.searchInputValue.length, SEARCH_MIN_LENGTH)) {
      return;
    } else {
      this.closeAlert();
    }
    if (_4.isEmpty(this.searchInputValue)) {
      this.crnClearSearchCommand();
      return;
    }
    if (!this.showAlert) {
      this.crnSearchCommand(this.termId, this.searchInputValue)
        .then((data: any) => {
          if (_4.isEmpty(data.section)) {
            this.configAndShowAlert('noResults');
          }
        })
        .catch((error: any) => {
          if (error.status === 404) {
            this.configAndShowAlert('serverError');
          }
        });
    }
  }

  noResultsFound() {
    this.alertConfig = this.ALERT_TYPES.noResults;
  }

  gotoRegistration() {
    this.$state.go('my.schedule.registration');
  }
}

angular.module('capability-ng-scheduler').component('crnSearch', {
  templateUrl: 'capability-ng-scheduler/src/components/crn_search/crn_search.html',
  controller: CRNSearchController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/crn_search/crn_search.ts